import { useLocation } from 'react-router';

import { BASIC_DATA_TABLE_DISPLAY_ROWS, SHARED_DASHBOARD_PATH } from '@/features/dashboard';

import MultiGroupTableTab from './MultiGroupTableTab';
import { useMultiGroupTableData } from './useMultiGroupTableData';

import type { MultiGroupTableSectionType } from '@/features/markets/types';

const MultiGroupTable = ({
  layout,
  sections
}: {
  sections: MultiGroupTableSectionType[] | undefined;
  layout?: { fullWidth?: boolean; height?: number };
}) => {
  const { pathname } = useLocation();
  const isDashboard = pathname.startsWith('/dashboard') || pathname === SHARED_DASHBOARD_PATH;
  const height = layout?.height ?? (isDashboard ? BASIC_DATA_TABLE_DISPLAY_ROWS : undefined);
  const { sections: enrichedSections, isLoading } = useMultiGroupTableData(sections);

  return (
    enrichedSections && (
      <MultiGroupTableTab
        height={height}
        isLoading={isLoading}
        sections={enrichedSections}
      />
    )
  );
};

export default MultiGroupTable;
